// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0d4f9d","secondary":"#ff1744","circle":"PulsingCircle_circle__2t8wt","pulse":"PulsingCircle_pulse__12gNQ"};